



























import { Component, Mixins, Prop, Emit } from 'vue-property-decorator'
import * as DateUtil from '@/tcw/utils/DateUtil'
import TcwFormItemCommon from '@/components/common/form/mixins/TcwFormItemCommon'

@Component
export default class TcwFormItemDate extends Mixins(TcwFormItemCommon) {
  @Prop({ default: () => DateUtil.now() })
  private value!: Date
  @Prop({ type: Boolean, default: false })
  private todayButton!: boolean
  @Prop({ type: Boolean, default: false })
  private clearable!: boolean

  get isToday(): boolean {
    return DateUtil.equalsDate(DateUtil.now(), this.value)
  }

  @Emit()
  private input(_value: Date): void {
    /** */
  }

  @Emit()
  private change(_value: Date): void {
    /** */
  }

  private toToday(): void {
    this.changeDate(DateUtil.now())
  }
  private changeDate(newDate: Date): void {
    this.input(newDate)
    this.change(newDate)
  }
}
